import { primary } from "configs/colors";

import {
  config,
  loadLocalStorage,
  removeLocalStorage,
  saveLocalStorage,
} from "./storage";

export const THEME_KEY = "Theme:Org";
export const THEME_NAME = "Theme:Name";

export const initTheme = (
  theme?: Record<number, string>,
  themeName?: string
) => {
  if (loadLocalStorage(THEME_NAME) !== themeName && themeName && theme) {
    saveLocalStorage(THEME_KEY, theme);
    saveLocalStorage(THEME_NAME, themeName);
  }
  if (!themeName && loadLocalStorage(THEME_NAME)) {
    removeLocalStorage(THEME_KEY);
    removeLocalStorage(THEME_NAME);
  }
};

export const clearTheme = () => {
  removeLocalStorage(THEME_KEY);
  removeLocalStorage(THEME_NAME);
};

export const getPrimaryColor = () => {
  let primaryOrg = {};
  try {
    primaryOrg = JSON.parse(
      window.localStorage.getItem(`${config.prefix}:${THEME_KEY}`) || ""
    ) as string;
  } catch (error) {
    primaryOrg = {};
  }

  const finalPrimary = {
    ...primary,
    ...primaryOrg,
  };

  return finalPrimary;
};
